import { useContext } from "react";

import { OttPlanContext } from "../contexts/OttPlanContext";

const useOttPlan = () => {
  const context = useContext(OttPlanContext);

  if (!context) throw new Error("Ott Plan Context must be placed within Ott Plan Provider");

  return context;
};

export default useOttPlan;
